import React, { useContext, useState } from 'react';
import { WorkspaceContext } from '../../contexts/WorkspaceContext';
import './FavoritesSection.css';

function FavoritesSection({ selectedId, onSelect }) {
  const { favorites, unreadCounts, toggleFavorite } = useContext(WorkspaceContext);
  const [collapsed, setCollapsed] = useState(false);

  if (favorites.length === 0) return null;

  const getTypeIndicator = (conv) => {
    if (conv.type === 'CHANNEL') {
      return <span className="fav-type-indicator fav-type-channel">#</span>;
    }
    if (conv.type === 'AI') {
      return <span className="fav-type-indicator fav-type-ai-dot" />;
    }
    // DM — presence dot (default gray; parent can enhance later)
    return <span className="fav-type-indicator fav-type-dm-dot" />;
  };

  return (
    <div className="favorites-section">
      <div className="section-header">
        <button
          type="button"
          className="section-toggle"
          onClick={() => setCollapsed((c) => !c)}
          aria-expanded={!collapsed}
        >
          <svg
            className={`section-chevron ${collapsed ? 'collapsed' : ''}`}
            viewBox="0 0 16 16"
            width="10"
            height="10"
            fill="currentColor"
          >
            <path d="M4.646 4.646a.5.5 0 01.708 0L8 7.293l2.646-2.647a.5.5 0 01.708.708l-3 3a.5.5 0 01-.708 0l-3-3a.5.5 0 010-.708z" />
          </svg>
          <span className="section-label-star">&#9733;</span>
          <span className="section-label">Favorites</span>
        </button>
      </div>
      {!collapsed && (
        <div className="section-list">
          {favorites.map((conv) => {
            const unread = unreadCounts[conv.id] || 0;
            return (
              <div
                key={conv.id}
                className={`fav-item-row ${selectedId === conv.id ? 'selected' : ''}`}
              >
                <button
                  type="button"
                  className={`fav-item ${unread > 0 ? 'fav-item-unread' : ''}`}
                  onClick={() => onSelect(conv)}
                  aria-pressed={selectedId === conv.id}
                >
                  {getTypeIndicator(conv)}
                  <span className="fav-name">{conv.title || 'Untitled'}</span>
                  {conv.aiEnabled && (
                    <span className="channel-ai-indicator" aria-label="AI enabled" role="img">
                      AI
                    </span>
                  )}
                  {unread > 0 && (
                    <span className="unread-badge">{unread > 99 ? '99+' : unread}</span>
                  )}
                </button>
                <button
                  type="button"
                  className="fav-remove-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite(conv.id);
                  }}
                  aria-label={`Remove ${conv.title} from favorites`}
                  title="Remove from favorites"
                >
                  <svg viewBox="0 0 16 16" width="11" height="11" fill="currentColor">
                    <path d="M4.646 4.646a.5.5 0 01.708 0L8 7.293l2.646-2.647a.5.5 0 01.708.708L8.707 8l2.647 2.646a.5.5 0 01-.708.708L8 8.707l-2.646 2.647a.5.5 0 01-.708-.708L7.293 8 4.646 5.354a.5.5 0 010-.708z" />
                  </svg>
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default FavoritesSection;
